import apiCore from '../../utils/api-core';


export function deleteScheduledMessage(id) {
	return apiCore.delete(`/api/v1/scheduled/${id}`);
}